interface InputGroupProps {
	label: string;
	value: string;
	onChange: (v: string) => void;
	placeholder?: string;
	type?: string;
	className?: string;
	disabled?: boolean;
}

export const InputGroup = ({
	label,
	value,
	onChange,
	placeholder,
	type = "text",
	className = "",
	disabled = false,
}: InputGroupProps) => (
	<div className={`form-group ${className}`}>
		<label htmlFor={label} className="form-label">
			{label}
		</label>
		<input
			id={label}
			type={type}
			value={value}
			onChange={(e) => onChange(e.target.value)}
			placeholder={placeholder}
			className="form-control"
			disabled={disabled}
		/>
	</div>
);
